var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-demo"},[_c('div',{staticClass:"header-demo__inner"},[_c('a',{staticClass:"header-demo__logo_link",attrs:{"href":"/"}},[_c('img',{staticClass:"header-demo__logo_img",attrs:{"src":require("assets/img/main/logo--mts-icon-full.svg"),"alt":"logo","width":"68","height":"26"}})])])])
}]

export { render, staticRenderFns }